export const unicodeReplacements = [
  {from: "●", to: "●", pseudo: "PLACEHOLDERJAPAN"},
  {from: "▲", to: "▲", pseudo: "PLACEHOLDERTRIANGLE"},
].map(replacement => ({
  ...replacement,
  type: "significant",
}));
